import { useCallback, useState } from 'react';
import { useAppDispatch } from 'store/hooks';
import { createDevice } from 'modules/devices/store/actions';
import { toast } from 'react-toastify';

export function useCreateDevice(tournamentId: number | null, refetch: () => void) {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const mutate = useCallback(
    async (params: { name: string }) => {
      if (!tournamentId) return;
      setIsLoading(true);
      try {
        await dispatch(createDevice({ name: params.name, tournament_id: tournamentId })).unwrap();
        toast.success('Устройство создано');
        refetch();
      } catch {
        toast.error('Не удалось создать устройство');
      } finally {
        setIsLoading(false);
      }
    },
    [dispatch, tournamentId, refetch],
  );

  return { mutate, isLoading };
}
